import { useQuery } from 'react-query';
import request from 'app/api/request';
export const useGetCurrentLock = (documentSuperId, sectionSuperId) => {
  return useQuery(
    ['documentLock', documentSuperId, sectionSuperId],
    async () => {
      const response = await request.get(`/gaby/locks/${documentSuperId}/${sectionSuperId}`);
      return response.data;
    },
    {
      enabled: !!documentSuperId && !!sectionSuperId,
    }
  );
};
